const DOCUMENT_TYPE_ROUTE = '/final-document-type'
const DOCUMENT_TYPE_OPTIONS_ROUTE = `${DOCUMENT_TYPE_ROUTE}/list`

export { DOCUMENT_TYPE_ROUTE, DOCUMENT_TYPE_OPTIONS_ROUTE }
